import { render, staticRenderFns } from "./ItemListMisuraMTM.vue?vue&type=template&id=1f25f3bf"
import script from "./ItemListMisuraMTM.vue?vue&type=script&lang=ts"
export * from "./ItemListMisuraMTM.vue?vue&type=script&lang=ts"
import style0 from "./ItemListMisuraMTM.vue?vue&type=style&index=0&id=1f25f3bf&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Progetti\\Filolog\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f25f3bf')) {
      api.createRecord('1f25f3bf', component.options)
    } else {
      api.reload('1f25f3bf', component.options)
    }
    module.hot.accept("./ItemListMisuraMTM.vue?vue&type=template&id=1f25f3bf", function () {
      api.rerender('1f25f3bf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/mtm/ItemListMisuraMTM.vue"
export default component.exports